import { IconX } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/**
 * Removable chip for an ASIN filter carried over from the dashboard ("ASIN · 2 ×"):
 * the list pages show it so a narrowed list never looks like the full one.
 */
export function AsinFilterChip({
  asins,
  onClear,
  className,
}: {
  asins: readonly string[];
  onClear: () => void;
  className?: string;
}): React.ReactElement {
  const { t } = useTranslation("common");
  return (
    <button
      type="button"
      title={asins.join(", ")}
      aria-label={t("asinFilter.clear", { asins: asins.join(", ") })}
      onClick={onClear}
      className={cn(
        "flex h-8 shrink-0 items-center gap-1.5 rounded-sm bg-control-highlight pr-2 pl-2.5 text-xs text-ink outline-none transition-colors duration-[var(--duration-fast)] hover:bg-state-hover focus-visible:ring-2 focus-visible:ring-focus-ring",
        className,
      )}
    >
      <span className="text-text-secondary">ASIN</span>
      <span aria-hidden className="text-placeholder">
        ·
      </span>
      <span className="tabular-nums">{asins.length === 1 ? asins[0] : asins.length}</span>
      <IconX aria-hidden className="size-3.5 text-muted-foreground" stroke={2} />
    </button>
  );
}
